import InputMultiSelectStore from "components/input-multiselect-store";
import { useStoresCatalog } from "../../hooks/useStoresCatalog";
import { useOfmFiltersState } from "../../ducks/filter/hooks/state";
import { useOfmFiltersActions } from "../../ducks/filter/hooks/actions";

export default function StoreFilter() {
  const { filters } = useOfmFiltersState();
  const { setCodes, setCode } = useOfmFiltersActions();
  const { stores, isLoading, isError } = useStoresCatalog();

  const selectedCodes: string[] = Array.isArray(filters?.codes)
    ? (filters.codes as string[])
    : (filters?.code ? [String(filters.code)] : []);

  const handleChange = (codes: string[]) => {
    setCodes(codes);
    setCode(codes.length === 1 ? codes[0] : undefined);
  };

  return (
    <InputMultiSelectStore
      label="Loja"
      items={stores}
      selectedCnpjs={selectedCodes}
      onChange={handleChange}
      placeholder={
        isLoading ? "Carregando..." :
          isError ? "Erro ao carregar" :
            "Selecionar loja"
      }
    />
  );
}
